import * as React from 'react';
import { Header4, InlineText2, Paragraph3 } from '@cian/ui-kit';
import { Bank24 } from '@cian/ui-kit/icons';

import { IPromoBank } from '../../../../types/newbuilding/promos';
import * as styles from './BankItem.css';

interface IBankItemProps {
  bank: IPromoBank;
  label?: string;
  onMortgageClick?(): void;
}

export function BankItem({ bank, label, onMortgageClick }: IBankItemProps) {
  return (
    <div className={styles['item']}>
      <div className={styles['logo']}>
        {bank.secondSquareImageUrl || bank.logoUrl ? (
          <img className={styles['logo-image']} src={bank.secondSquareImageUrl || bank.logoUrl} alt="" />
        ) : (
          <div className={styles['logo-icon']}>
            <Bank24 />
          </div>
        )}
      </div>
      <div className={styles['content']}>
        {label && <Paragraph3 color="gray60_100">{label}</Paragraph3>}
        <Header4>{bank.name}</Header4>
      </div>
      {bank.cianMortgagePartnerLink && (
        <a
          className={styles['link']}
          href={bank.cianMortgagePartnerLink}
          onClick={onMortgageClick}
          target="_blank"
          rel="noreferrer"
        >
          <InlineText2 color="primary_100">Партнер Циан.Ипотеки</InlineText2>
        </a>
      )}
    </div>
  );
}
